<template>
  <section class="content">
    <modal-negar
      v-if="showModalNegar"
      @close="showModalNegar = false"
      @negar="(motivo, observacao) => negar(motivo, observacao)"
    ></modal-negar>
    <modal-acerto-atendimento
      v-if="showModalAcertoAtendimento"
      :boletoId = "controle.boleto_id"
      @close="showModalAcertoAtendimento = false"
      @updateBoleto="(boletoId, dados) => updateBoleto(boletoId, dados)"
    ></modal-acerto-atendimento>
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Análise da Garantia</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-12">
                <h4>Dados da Solicitação</h4>
                <table class="table table-bordered table-hover" role="grid">
                  <thead>
                    <tr role="row">
                      <th style="width:8%">Protocolo</th>
                      <th style="width:14%">Data</th>
                      <th style="width:18%">Empresa</th>
                      <th style="width:18%">Pessoa</th>
                      <th style="width:12%">Cpf/Cnpj</th>
                      <th style="width:22%">Telefone</th>
                      <th style="width:5%">Quant.</th>
                      <th style="width:13%">Situação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" class="odd">
                      <td>{{ dados.id }}-{{ dados.digito }}</td>
                      <td>{{ dados.data | dataHoraFormatada }}</td>
                      <td>{{ dados.usuario.empresa.fantasia }}</td>
                      <td>{{ dados.pessoa.nome_razao }}</td>
                      <td>{{ dados.pessoa.cpf_cnpj }}</td>
                      <td>{{ dados.pessoa.telefone1 }} {{ dados.pessoa.telefone2 && dados.pessoa.telefone2 != '' ? ` ${dados.pessoa.telefone2}` : '' }}</td>
                      <td>{{ dados.qtd_titulo }}</td>
                      <td>
                        <strong :class="dados.status">{{ dados.status }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  class="table table-bordered table-hover"
                  role="grid"
                  v-if="dados.motivo  || dados.observacao"
                >
                  <thead>
                    <tr role="row">
                      <th style="width:50%">Motivo</th>
                      <th style="width:50%">Observação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" class="odd">
                      <td>{{ dados.motivo }}</td>
                      <td>{{ dados.observacao }}</td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-bordered table-hover" role="grid">
                  <thead>
                    <tr role="row">
                      <th style="width:auto">Endereço</th>
                      <th style="width:auto">Número</th>
                       <th style="width:auto">Complemento</th>
                      <th style="width:auto">Bairro</th>
                      <th style="width:auto">Cidade</th>
                      <th style="width:auto">Estado</th>
                      <th style="width:auto">Ref. Comercial</th>
                      <th style="width:auto">Telefone</th>
                      <th style="width:auto">Ref. Pessoal</th>
                      <th style="width:auto">Telefone</th>
                      <th style="width:auto">Ocupação</th>
                      <th style="width:auto">Renda</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" class="odd">
                      <td>{{ dados.pessoa.endereco }}</td>
                      <td>{{ dados.pessoa.numero }}</td>
                       <td>{{ dados.pessoa.complemento }}</td>
                      <td>{{ dados.pessoa.bairro }}</td>
                      <td>{{ dados.pessoa.cidade }}</td>
                      <td>{{ dados.pessoa.uf }}</td>
                      <td>{{ dados.pessoa.ref_comercial }}</td>
                      <td>{{ dados.pessoa.tel_ref_comercial }}</td>
                      <td>{{ dados.pessoa.ref_pessoal }}</td>
                      <td>{{ dados.pessoa.tel_ref_pessoal }}</td>
                      <td>{{ dados.pessoa.ocupacao }}</td>
                      <td>{{ dados.pessoa.renda | numberFormat(2,',','.')}}</td>
                    </tr>
                  </tbody>
                </table>

                <div class="box collapsed-box solid">
                  <div class="box-header with-border">
                    <h3 class="box-title">Documentação</h3>
                    <div class="box-tools pull-right">
                      <button type="button" class="btn btn-box-tool" data-widget="collapse">
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div
                        style="margin-top: 12px;"
                        class="col-sm-10 col-sm-offset-2"
                        v-for="(documento, key) in documentacao"
                        :key="key"
                      >
                        <img style="width: 600px; height: 400px" :src="documento">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="box collapsed-box solid">
                  <div class="box-header with-border">
                    <h3 class="box-title">Duplicatas Assinadas</h3>
                    <div class="box-tools pull-right">
                      <button type="button" class="btn btn-box-tool" data-widget="collapse">
                        <i class="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div
                        style="margin-top: 12px;"
                        class="col-sm-10 col-sm-offset-2"
                        v-for="(duplicata, key) in duplicatas"
                        :key="key"
                      >
                        <img style="width: 600px; height: 400px" :src="duplicata">
                      </div>
                    </div>
                  </div>
                </div>

                <!--
                <h4>Telefones</h4>
                <table class="table table-bordered table-hover" role="grid">
                  <thead>
                    <tr role="row">
                      <th style="width:10%">ID</th>
                      <th style="width:30%">Telefone</th>
                      <th style="width:48%">Contato</th>
                      <th style="width:12%">Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" class="odd">
                      <td>1</td>
                      <td>{{ dados.pessoa.tel1 }}</td>
                      <td>---</td>
                      <td>---</td>
                    </tr>
                     <tr role="row" class="odd" v-if="dados.pessoa.tel2 != ''">
                      <td>2</td>
                      <td>{{ dados.pessoa.tel2 }}</td>
                      <td>---</td>
                      <td>---</td>
                    </tr>
                     <tr role="row" class="odd" v-if="dados.pessoa.tel3 != ''">
                      <td>3</td>
                      <td>{{ dados.pessoa.tel3 }}</td>
                      <td>---</td>
                      <td>---</td>
                    </tr>
                  </tbody>
                </table>
                -->
                <h4>Dados dos Boletos</h4>
                <table class="table table-bordered table-hover" role="grid">
                  <thead>
                    <tr role="row">
                      <th style="width:10%">Garantia</th>
                      <th style="width:30%">Valor</th>
                      <th style="width:30%">Vencimento</th>
                      <th style="width:20%">Situação</th>
                      <th style="width:10%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="boleto in dados.boletos" :key="boleto.id" role="row" class="odd">
                       <td>{{ boleto.id }}-{{ boleto.digito }}</td>
                      <td>{{ boleto.valor | numberFormat(2,',','.') }}</td>
                      <td>{{ boleto.vencimento | dataFormatada }}</td>
                      <td>{{ boleto.situacao }}</td>
                       <td>
                          <button class="btn btn-warning btn-sm" title="Acerto de Atendimento" @click="getModalAcertoAtendimento(boleto.id)">
                            <i class="fa fa-fw fa-edit"></i>
                          </button>
                          <button v-if="boleto.situacao == 'DISPONÍVEL PARA PAGAMENTO' || boleto.situacao == 'ENVIADO PARA REGISTRO' || boleto.situacao == 'GARANTIDO'" class="btn btn-danger btn-sm" title="Cancelar" @click="cancelarBoleto(boleto.id)">
                            <i class="fa fa-fw fa-close"></i>
                          </button>
                        </td>
                    </tr>
                  </tbody>
                </table>

                <h4>Boletos Anteriores</h4>
                <table class="table table-bordered table-hover" role="grid">
                  <thead>
                    <tr role="row">
                      <th style="width:50%">Valor</th>
                      <th style="width:50%">Vencimento</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-for="garantia in dados.pessoa.garantias"
                      v-if="dados.id != garantia.id && dados.id > garantia.id"
                    >
                      <tr
                        v-for="boleto in garantia.boletos"
                        :key="boleto.id"
                        role="row"
                        class="odd"
                        style="color:red"
                      >
                        <td>{{ boleto.valor | numberFormat(2,',','.') }}</td>
                        <td>{{ boleto.vencimento | dataFormatada }}</td>
                       
                      </tr>
                    </template>
                  </tbody>
                </table>

                <div v-html="htmlConsultaRestritiva"></div>
                <div v-html="htmlConsultaAnalitica"></div>

                <div class="box-footer text-right" style="margin-top:20px;">
                  <button
                    class="btn btn-info"
                    @click="liberaBoleto"
                    v-if="dados.status == 'APROVADO' && dados.libera_boleto != 'S'"
                  >Libera Boleto(s)</button>
                  <button
                    class="btn btn-success"
                    @click="aprovar"
                    v-if="dados.status == 'PENDENTE'"
                  >Aprovar</button>
                  <button
                    class="btn btn-danger"
                    @click="showModalNegar = true"
                    v-if="dados.status == 'PENDENTE'"
                  >Negar</button>
                  <button
                    class="btn btn-warning"
                    @click="consultaAnalitica"
                    :disabled="htmlConsultaAnalitica != ''"
                  >Consulta Analítica</button>
                  <button
                    class="btn btn-primary"
                    @click="consultaRestritiva"
                    :disabled="htmlConsultaRestritiva != ''"
                  >Consulta Restritiva</button>
                  <button
                    class="btn btn-danger"
                    @click="cancelarGarantia()"
                    v-if="dados.status == 'APROVADO'"
                  >Cancelar Garantia</button>
                  <a class="btn btn-default">Voltar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http

import modalNegar from "./modalNegar";
import modalAcertoAtendimento from "./modalAcertoAtendimento";

export default {
  data() {
    return {
      documentacao: [],
      duplicatas: [],
      showModalNegar: false,
      showModalAcertoAtendimento: false,
      htmlConsultaRestritiva: "",
      htmlConsultaAnalitica: "",
      dados: {
        pessoa: {
          nome_razao: "",
          cpf_cnpj: ""
        },
        usuario: {
          empresa: {
            fantasia: "",
            razao: ""
          }
        }
      },
      controle: {
        boleto_id: null
      }
    };
  },
  mounted() {
    if (this.$route.params.garantiaId) {
      this.getDetalhe(this.$route.params.garantiaId);
    }
  },

  methods: {
   getModalAcertoAtendimento(boletoId) {
      this.controle.boleto_id = boletoId;
      this.showModalAcertoAtendimento = true;
    },
    getDetalhe(garantiaId) {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/garantia/getById/${garantiaId}`,
          config
        )
        .then(response => {
          this.dados = response.data;
          this.$nextTick(() => {
            this.getDocumentacao();
            this.getDuplicatas();
          });
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    consultaRestritiva() {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/garantia/consultaRestritiva/${
            this.dados.id
          }`,
          config
        )
        .then(response => {
          this.htmlConsultaRestritiva = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    consultaAnalitica() {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/garantia/consultaAnalitica/${
            this.dados.id
          }`,
          config
        )
        .then(response => {
          this.htmlConsultaAnalitica = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    updateBoleto(boletoId, dados) {
       axios
        .post(
          `${this.$store.state.serverURI}/api/boleto/update/${boletoId}`,
          {dados},
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.$swal({
            type: response.data.status == 200 ? "success" : "error",
            title:
              response.data.status == 200
                ? "Tudo Certo!"
                : "Ops! Ocorreu um erro.",
            text: response.data.msg,
            showConfirmButton: false,
            timer: 1000
          });
          this.showModalAcertoAtendimento = false;
          this.controle.boleto_id = null;
          this.getDetalhe(this.$route.params.garantiaId);
        })
        .catch(erro => {
          this.$swal({
            type: "error",
            title: "Ops! Ocorreu um erro.",
            text: erro,
            showConfirmButton: true
          });
        });
    },
    negar(motivo, observacao) {
      axios
        .post(
          `${this.$store.state.serverURI}/api/garantia/negar/${
            this.dados.id
          }/${motivo}/${observacao}`,
          {},
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.$swal({
            type: response.data.status == 200 ? "success" : "error",
            title:
              response.data.status == 200
                ? "Tudo Certo!"
                : "Ops! Ocorreu um erro.",
            text: response.data.msg,
            showConfirmButton: false,
            timer: 1500
          });
          this.showModalNegar = false;
          this.getDetalhe(this.$route.params.garantiaId);
        })
        .catch(erro => {
          this.$swal({
            type: "error",
            title: "Ops! Ocorreu um erro.",
            text: erro,
            showConfirmButton: true
          });
        });
    },
    aprovar() {
      this.$swal({
        title: "Confirmação da Aprovação!",
        text: "Confirma aprovação dessa solicitação de garantia?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/garantia/aprovar/${
                this.dados.id
              }`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDetalhe(this.$route.params.garantiaId);
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },
    cancelarGarantia() {
      this.$swal({
        title: "Confirmação de Cancelamento!",
        text: "Confirma cancelamento dessa garantia?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/garantia/cancelar/${
                this.dados.id
              }`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDetalhe(this.$route.params.garantiaId);
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },
    cancelarBoleto(boletoId) {
      this.$swal({
        title: "Confirmação de Cancelamento!",
        text: "Confirma o cancelamento do boleto selecionado?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/boleto/cancelar/${
                boletoId
              }`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDetalhe(this.$route.params.garantiaId);
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },
    liberaBoleto() {
      this.$swal({
        title: "Confirmação da Liberação!",
        text: "Confirma liberação de impressão dos boletos para essa garantia?",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
        cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .post(
              `${this.$store.state.serverURI}/api/garantia/liberaBoleto/${
                this.dados.id
              }`,
              {},
              this.$store.getters.getHeaderAuth
            )
            .then(response => {
              this.$swal({
                type: response.data.status == 200 ? "success" : "error",
                title:
                  response.data.status == 200
                    ? "Tudo Certo!"
                    : "Ops! Ocorreu um erro.",
                text: response.data.msg,
                showConfirmButton: false,
                timer: 1500
              });
              this.getDetalhe(this.$route.params.garantiaId);
            })
            .catch(erro => {
              this.$swal({
                type: "error",
                title: "Ops! Ocorreu um erro.",
                text: erro,
                showConfirmButton: true
              });
            });
        }
      });
    },
    getDocumentacao() {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/pessoa/getDocumentacao/${
            this.dados.pessoa.id
          }`,
          config
        )
        .then(response => {
          let caminhos = response.data;
          let documentacao = [];
          caminhos.map(caminho => {
            documentacao.push(`${this.$store.state.s3URI}/${caminho}`);
          });
          this.documentacao = documentacao;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    },
    getDuplicatas() {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/garantia/getDuplicatas/${
            this.$route.params.garantiaId
          }`,
          config
        )
        .then(response => {
          let caminhos = response.data;
          let duplicatas = [];
          caminhos.map(caminho => {
            duplicatas.push(`${this.$store.state.s3URI}/${caminho}`);
          });
          this.duplicatas = duplicatas;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    }
  },
  watch: {},

  components: {
    modalNegar,
    modalAcertoAtendimento
  }
};
</script>
<style scoped>
table tr td {
  text-transform: uppercase;
}
.APROVADO {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// detalhe.vue?63036f6a